import { render, staticRenderFns } from "./EditTaskForm.vue?vue&type=template&id=31913d36&scoped=true&"
import script from "./EditTaskForm.vue?vue&type=script&lang=js&"
export * from "./EditTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31913d36",
  null
  
)

export default component.exports